import * as actionTypes from './actionTypes';

export const sessionTokenSuccess = (sessionToken) => {
  return {
    type: actionTypes.SESSION_TOKEN_SUCCESS,
    sessionToken,
  };
};

export const sessionTokenFailed = (error) => {
  return {
    type: actionTypes.SESSION_TOKEN_FAILED,
    error,
  };
};

export const signUpStart = () => {
  return {
    type: actionTypes.SIGN_UP_START,
  };
};

export const signUpSuccess = (UserId, CodeSentTo) => {
  return {
    type: actionTypes.SIGN_UP_SUCCESS,
    UserId,
    CodeSentTo,
  };
};

export const signUpFailed = (error) => {
  return {
    type: actionTypes.SIGN_UP_FAILED,
    error,
  };
};

export const verifyAccount = (UserId, Code) => {
  return {
    type: actionTypes.VERIFY_ACCOUNT,
    UserId,
    Code,
  };
};

export const verifyAccountStart = () => {
  return {
    type: actionTypes.VERIFY_ACCOUNT_START,
  };
};

export const verifyAccountSuccess = (SessionToken, VerifiedMedium) => {
  return {
    type: actionTypes.VERIFY_ACCOUNT_SUCCESS,
    SessionToken,
    VerifiedMedium,
  };
};

export const verifyAccountFailed = (error) => {
  return {
    type: actionTypes.VERIFY_ACCOUNT_FAILED,
    error,
  };
};

export const resendAccountVerificationCode = (UserId, Verify) => {
  return {
    type: actionTypes.RESEND_ACCOUNT_VERIFICATION_CODE,
    Verify,
    UserId,
  };
};

export const resendAccountVerificationCodeStart = () => {
  return {
    type: actionTypes.RESEND_ACCOUNT_VERIFICATION_CODE_START,
  };
};

export const resendAccountVerificationCodeSuccess = (SessionToken, VerifiedMedium) => {
  return {
    type: actionTypes.RESEND_ACCOUNT_VERIFICATION_CODE_SUCCESS,
    VerifiedMedium,
  };
};

export const resendAccountVerificationCodeFailed = (error) => {
  return {
    type: actionTypes.RESEND_ACCOUNT_VERIFICATION_CODE_FAILED,
    error,
  };
};

export const accountNeedsVerification = (CodeSentTo) => {
  return {
    type: actionTypes.ACCOUNT_NEEDS_VERIFICATION,
    CodeSentTo,
  };
};

export const signIn = (Email, Password, TempPass) => {
  return {
    type: actionTypes.SIGN_IN,
    Email,
    Password,
    TempPass,
  };
};

export const signInStart = () => {
  return {
    type: actionTypes.SIGN_IN_START,
  };
};

export const signInSuccess = (UserId, ForceNewPassword, sessionToken) => {
  return {
    type: actionTypes.SIGN_IN_SUCCESS,
    UserId,
    ForceNewPassword,
    sessionToken,
  };
};

export const signInFailed = (error, accountVerified, CodeSentTo, UserId) => {
  return {
    type: actionTypes.SIGN_IN_FAILED,
    error,
    accountVerified,
    CodeSentTo,
    UserId,
  };
};

export const requestPasswordReset = (Email) => {
  return {
    type: actionTypes.REQUEST_PASSWORD_RESET,
    Email,
  };
};

export const requestPasswordResetStart = () => {
  return {
    type: actionTypes.REQUEST_PASSWORD_RESET_START,
  };
};

export const requestPasswordResetSuccess = (successMessage) => {
  return {
    type: actionTypes.REQUEST_PASSWORD_RESET_SUCCESS,
    successMessage,
  };
};

export const requestPasswordResetFailed = (error) => {
  return {
    type: actionTypes.REQUEST_PASSWORD_RESET_FAILED,
    error,
  };
};

export const returnToPasswordResetRequest = () => {
  return {
    type: actionTypes.RETURN_TO_PASSWORD_RESET_REQUEST,
  };
};

export const logout = (isAutoLogout) => {
  return {
    type: actionTypes.LOGOUT,
    isAutoLogout,
  };
};

export const logoutStart = () => {
  return {
    type: actionTypes.LOGOUT_START,
  };
};

export const logoutSuccess = () => {
  return {
    type: actionTypes.LOGOUT_SUCCESS,
  };
};

export const logoutFailed = (error) => {
  return {
    type: actionTypes.LOGOUT_FAILED,
    error,
  };
};

export const resetAuthData = () => {
  return {
    type: actionTypes.RESET_AUTH_DATA,
  };
};
